import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * XP to test the rollout of `enablePageUpdateFix: "v2"` on certain pages.
 */
export const FE_UPLT_HISTORY_TIMING_V2_250401 = experiment({
  name: "FE_UPLT_HISTORY_TIMING_V2_250401",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-10-31",
  defaultValue: false,
  productArea: "FRONTEND_APIS",
});
